import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

/**
 * Tracks in-app URL history so components can tell whether the user has a previous
 * in-app route to go back to, without relying on document.referrer or browser history.
 */
@Injectable({
  providedIn: 'root'
})
export class RouteHistoryService {

  private history: string[] = [];

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        this.history.push(event.urlAfterRedirects);
      });
  }

  get previousUrl(): string | undefined {
    return this.history[this.history.length - 2];
  }

  hasPreviousRoute(): boolean {
    return this.history.length > 1;
  }
}
